/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'support';
const componentName = 'tech-support-wizard';
const prefix = `${moduleName}.${componentName}`;

export const techSupportLabel = `${prefix}.techSupportLabel`;
export const preCheckLabel = `${prefix}.preCheckLabel`;
export const packagingLabel = `${prefix}.packagingLabel`;

export const ENGLISH = {
    [techSupportLabel]: 'Tech Support',
    [preCheckLabel]: 'Pre-check',
    [packagingLabel]: 'Packaging',
};
